import React from 'react'

const SelectInput = React.forwardRef((props, ref) => (
  <label className='league-label'>
    {props.label}
    <select className='league-control' {...props} ref={ref}>
      { props.options.map((o, i) => <option key={i} value={o[0]}>{o[1]}</option>) }
    </select>
  </label>
))

export default SelectInput
